import { render, staticRenderFns } from "./detail-toutiao.vue?vue&type=template&id=7034a01e&"
import script from "./detail-toutiao.vue?vue&type=script&lang=js&"
export * from "./detail-toutiao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports